import { render } from "./WhatsNew.vue?vue&type=template&id=a586f53e&scoped=true&ts=true"
import script from "./WhatsNew.vue?vue&type=script&lang=ts"
export * from "./WhatsNew.vue?vue&type=script&lang=ts"

import "./WhatsNew.vue?vue&type=style&index=0&id=a586f53e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a586f53e"]])

export default __exports__